/**
 * "DID YOU REQUEST ACCESS?" — the desktop modal. Chrome only; the question and
 * every string live in `components/PtAskBody.tsx` / `selectors.3e#ptAskVM`.
 *
 * Mounted by `DesktopApp` while `s.ptAsk !== ''`. 520px, the narrowest of the
 * §4 widths: this is one card and two buttons, not a panel.
 *
 * It opens OVER the playtest detail modal when that modal's REQUEST ACCESS
 * raised it, which the shared Escape stack already handles correctly — LIFO
 * closes the question first and leaves the sheet that asked it standing.
 */

import { PtAskBody, usePtAsk } from '../../components/PtAskBody.tsx';
import { useQd } from '../../store/index.ts';
import { Modal } from '../components/Modal.tsx';

export default function PtAskModal(): JSX.Element | null {
  const s = useQd();
  const v = usePtAsk();
  if (!v) return null;

  return (
    <Modal
      label="Playtest request confirm"
      width={520}
      onClose={s.closePtAsk}
      header={{ title: v.title, titleClr: 'var(--acc)', note: v.srcTxt }}
    >
      <PtAskBody v={v} m={{ hero: 148, pad: '14px 16px 18px', gap: 12 }} />
    </Modal>
  );
}
